import type { AxiosResponse } from "axios";
import { createMutation } from "react-query-kit";

import type { IAppointmentCommentDto } from "@api/appointment/types";
import { generatePath } from "@routes/generatePath.ts";
import { useAppointmentTable } from "@api/appointment/getAppointmentTable";
import { useShowAppointment } from "@api/appointment/showAppointment";
import { useAppointmentDetail } from "@api/appointment/getAppointmentDetail";
import { useComments } from "@api/comments/getComments";
import type { IApiResponse, IAxiosFn } from "@/api";
import { axiosClient, queryClient } from "@/api";

type IResponse = AxiosResponse<IApiResponse<unknown>>;
type IVariables = IAppointmentCommentDto;
export const postCommentAppointment: IAxiosFn<IVariables, IResponse> = (
  data,
  signal,
) => {
  return axiosClient.post(
    generatePath("/rating/:appointment_id", {
      appointment_id: data?.id,
    }),
    data,
    { signal },
  );
};

export const usePostCommentAppointment = createMutation<IResponse, IVariables>({
  mutationFn: (data) => postCommentAppointment(data),
  onSuccess: (_, { id }) => {
    queryClient.invalidateQueries(useComments.getKey());
    queryClient.invalidateQueries(useAppointmentTable.getKey());
    queryClient.invalidateQueries(
      useShowAppointment.getKey({ appointmentId: id }),
    );
    queryClient.invalidateQueries(
      useAppointmentDetail.getKey({ id: id?.toString() }),
    );
  },
});
